export default "__VITE_ASSET__juKlN4WL__"